import { render, staticRenderFns } from "./PosCovid19.vue?vue&type=template&id=e6f57d98"
import script from "./PosCovid19.vue?vue&type=script&lang=js"
export * from "./PosCovid19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports